const conditions = () => {
  return [{ assetClass: 'object.asset-class.options.kapitalgeber' }]
}

export default conditions
